import React, { forwardRef, useContext } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { ThemeContext } from "../Theme";

import styles from "./Container.scss";

export const Container = forwardRef(
  ({ children, variants, tag: CustomTag, customClass, ...props }, ref) => {
    const context = useContext(ThemeContext);

    const elementClasses = cx(variants, customClass, {
      [styles.container]: !variants,
      [styles[context]]: context,
    });

    return (
      <CustomTag className={elementClasses} ref={ref} {...props}>
        {children}
      </CustomTag>
    );
  }
);

Container.propTypes = {
  tag: PropTypes.string,
  customClass: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Container.defaultProps = {
  tag: "div",
  customClass: undefined,
  variants: styles.container,
};

Container.Variant = {
  centered: styles.centered,
  fixed: styles.fixed,
  fixedSmall: styles.fixedSmall,
  fixedLarge: styles.fixedLarge,
  padded: styles.padded,
  paddedTop: styles.paddedTop,
  paddedTopBig: styles.paddedTopBig,
  paddedTopSmall: styles.paddedTopSmall,
  paddedBottom: styles.paddedBottom,
  paddedBottomBig: styles.paddedBottomBig,
  paddedBottomSmall: styles.paddedBottomSmall,
  paddedLeft: styles.paddedLeft,
  paddedRight: styles.paddedRight,
  paddedVertical: styles.paddedVertical,
  paddedVerticalBig: styles.paddedVerticalBig,
  paddedVerticalSmall: styles.paddedVerticalSmall,
  paddedHorizontal: styles.paddedHorizontal,
  sizeToContent: styles.sizeToContent,
  unsetInnerAlignment: styles.unsetInnerAlignment,
};

Container.displayName = "Container";

export default Container;
